import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

/** @returns {{ plugins: object, userMatrix: object }} */
export async function fetchAppConfig() {
  const { data } = await axios.get(`${getApiBase()}/app-config`, { headers: authHeaders() });
  return data;
}

/** @returns {{ userMatrix: object }} */
export async function postAppConfigSessionInit() {
  const { data } = await axios.post(
    `${getApiBase()}/app-config/session-init`,
    {},
    { headers: authHeaders() }
  );
  return data;
}

/** Admin only. @returns {{ plugins: object, userMatrix: object }} */
export async function putAdminAppConfig(body) {
  const { data } = await axios.put(`${getApiBase()}/admin/app-config`, body, {
    headers: authHeaders(),
  });
  return data;
}

/** Admin: scan all projects' acf_groups_json for distinct field paths + inferred types. */
export async function fetchAdminFieldCatalogFromProjects() {
  const { data } = await axios.get(`${getApiBase()}/admin/field-catalog-from-projects`, {
    headers: authHeaders(),
  });
  return data;
}

export async function fetchInvitePreview(token) {
  const t = String(token || "").trim();
  const { data } = await axios.get(`${getApiBase()}/invites/${encodeURIComponent(t)}`);
  return data;
}

/** Admin: create app login + User Matrix entry (no invitation email). Password optional — server generates one when omitted. */
export async function postAdminCreateUser({ email, password, userTypeId }) {
  const body = { email, userTypeId };
  if (password != null && String(password).trim() !== "") {
    body.password = password;
  }
  const { data } = await axios.post(`${getApiBase()}/admin/users`, body, {
    headers: authHeaders(),
  });
  return data;
}
